export enum StatusEnum {
  ATIVO = 'Ativo',
  INATIVO = 'Inativo',
  EXCLUIDO = 'Excluído'
}
